import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getMenuSections } from '../components/layout/Sidebar';
import Layout from '../components/layout/Layout';

export default function Unauthorized() {
  const navigate = useNavigate();
  const { hasAnyPermission } = useAuth();

  // Get available modules from the sidebar configuration
  const menuSections = getMenuSections();
  const allMenuItems = menuSections.flatMap(section => section.items);
  
  const availableModules = allMenuItems
    .filter(item => !item.permissions || hasAnyPermission(item.permissions))
    .slice(0, 6); // Show only first 6 modules

  return (
    <Layout>
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="max-w-lg w-full bg-white rounded-lg border border-ink-200 shadow-panel p-8 sm:p-10 text-center">
          <div className="inline-flex h-14 w-14 items-center justify-center rounded-md bg-brand-900 text-accent-400 text-xl mb-5">
            <i className="fas fa-lock"></i>
          </div>
          <h1 className="text-2xl font-extrabold text-ink-900">Access Restricted</h1>
          <p className="mt-3 text-sm text-ink-500">
            You don't have permission to access this page. Contact your administrator if you need access.
          </p>
          
          {availableModules.length > 0 && (
            <div className="mt-6">
              <p className="text-xs font-extrabold uppercase tracking-[0.1em] text-ink-400 mb-3">Available modules</p>
              <div className="flex flex-wrap gap-2 justify-center">
                {availableModules.map(module => (
                  <button
                    key={module.path}
                    onClick={() => navigate(module.path)}
                    className="px-3 py-1.5 rounded-md bg-ink-50 border border-ink-200 text-ink-700 text-xs font-bold hover:bg-brand-50 hover:border-brand-200 hover:text-brand-800 transition-colors"
                  >
                    {module.label}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}
